import { PickupType } from "./order.store";

export class LocationsModel {
  locations?: (LocationsEntity)[] | null;
  bounds?: (BoundsEntity)[] | null;
  isFavoriteSearch: boolean;
  locationSearchType: LocationSearchType;
}

export enum LocationSearchType {
  Unit = 1,
  Zip = 2,
  City = 3,
  State = 4,
  Geocode = 5,
  Generic = 10
}
export interface LoyaltyConfig {
  loyaltyMode: LoyaltyMode;
}
export enum LoyaltyMode {
  Visits = 1,
  Points = 2
}
export class LocationsEntity {
  id: number;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  phone: string;
  locationName: string;
  nickName: string;
  longitude: number;
  latitude: number;
  capabilities?: (string)[] | null;
  unit: number;
  distance: number;
  distanceStr: string;
  etaTime: string;
  duration: string;
  timeZone: string;
  schedules?: (SchedulesEntity)[] | null;
  region: number;
  isFavorite: boolean;
  taxPercentage: number;
  matchesFilters?: boolean | null;
  openStatus: string;
  openInfo: string;
  taxRates?: (TaxRatesEntity)[] | null;
  viewPortDistance?: number | null;
  orderNumberFormat?: string | null;
  isAssumedLocation?: boolean | null;
  isPilot?: boolean;
  maxParkingCapacity: number | null;
  isCurbsideCheckInEnabled: boolean;
  isTableCheckInEnabled: boolean;
  parkingSpaces: string[];
  defaultDSPConfig: DspConfig;
  asapDefaultMax?: number;
  asapDefaultMin?: number;
  //When true, ASAP pickup list/radio uses store now through ServeEndTime.
  allowOrdersThroughServeEndTime?: boolean;
  isAutomaticDeliveryLocation?: boolean;
  content?:(LocationContent)[] | null;
  area?: number;
  zone?: number;
  fees:LocationFee[];
  operatingPartnerInfo?: PersonName;
  openCloseDisplayStatus: string;
  driveThruLaneInfo?: DriveThruLaneInfo;
  driveThruMode?: DriveThruMode;
  takeoutMode?: TakeoutMode;
}
export interface DriveThruLaneInfo {
  laneIdentifier: string;
  imageUrl: string;
}
export enum DriveThruMode {
  Standard = 1,
  DigitalLane = 2,
  DigitalOnly = 3    
}
export  enum TakeoutMode
{
    Standard = 1,
    FoodLocker = 2,
}

export interface LocationFee {
  id: number;
  enterpriseId: string;
  comment: string;
  name: string;
  percentage: number;
  taxable: boolean;
  effectiveUtc: string | null;
  expiryUtc: string | null;
  feeCalculationType: FeeCalculationType;
  value: number;
  pickupTypes: PickupType[];
}
export enum FeeCalculationType {
    Percentage = 1,
    Flat = 2        
}    
export interface PersonName {
  firstName?: string;
  middleName?: string;
  lastName?: string;
  displayName?: string;
}

export interface LocationContent {
  type: ContentType;
  bodyHtml: string;
  linkUrl: string;
  startDateTimeLocal: string;
  endDateTimeLocal: string;
  dailyStartTimeLocal: string | null;
  dailyEndTimeLocal: string | null;
  sort: number;
  audience?: CardAudience;
  destination?: ContentDisplayDestination;
}

export enum ContentType {
  ConfirmAndPayFooter = 1
}
export enum ContentDisplayDestination {
  Any = 0,
  Web = 1,
  Mobile = 2
}
export enum CardAudience {
  Any = 0,
  Guest = 1,
  SignedIn = 2
}
export interface DspConfig {
  allowedDsps: string;
  deliveryQuoteTypePreference: number;
  dspConfigId: number;
  maxDeliveryAmount: number;
  maxDeliveryFee: number;
  maxDeliveryMinutes: number;
  name: string;
}
export class TaxRatesEntity {
  effectiveUtc: string | null;
  taxRate: number | null;
  taxRoundingType?: number | 1;
}
export class SchedulesEntity {
  id: number;
  serviceArea: number;
  scheduleType: number;
  effectiveDate: string;
  days?: (DaysEntity)[] | null;
  reason: string;
}
export class DaysEntity {
  days: number;
  openTime: string;
  closeTime: string;
}
export class BoundsEntity {
  latitude: number;
  longitude: number;
}

export class DistanceMatrixEntity {
  from: BoundsEntity;
  to: BoundsEntity;
}
export class UnitLocation {
  locations: LocationsEntity[] | null;
  bounds: any[] | null;
  locationSearchType: number | null;
}


